import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  CssBaseline,
  Autocomplete,
  FormLabel,
  Drawer,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ReactQuill from "react-quill";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";

import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../Components/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import StatusAlert from "../../StatusAlertList/StatusAlert";
import { getKeysAndValues } from "../../utils/getKeysAndValues";
import { useNavigate } from "react-router-dom";
import config from "../../Data/AuthUser";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { ConveyApis, convoyApis } from "../../Data/axios";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Convoy() {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  // Add Convoy drawer state
  const [addConvoyOpen, setAddConvoyOpen] = useState(false);
  const [convoyForm, setConvoyForm] = useState({
    user_id: "",
    start_location: "",
    end_location: "",
    start_date: null,
    start_time: "",
    start_address: "",
    status: "0",
    owner_id: "",
    owner_permission: "",
    create_at: "",
  });
  const [member, setMember] = React.useState("");
  const [leaveType, setLeaveType] = React.useState("");
  const [optionsAgent, setOptionsAgent] = useState([]);
  const [duration, setDuration] = React.useState("");
  const [date, setDate] = useState(null); // Initialize state for the date
  const [memberError, setMemberError] = React.useState(false);
  const [reason, setReason] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState("");
  const [fileName, setFileName] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openNotes, setOpenNotes] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [pageValue, setPageValue] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowCountValue, setRowCountValue] = useState(0);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [followup, setFollowup] = React.useState(false);
  const [follow_agent, setFollow_agent] = useState("");
  const [follow_date, setFollow_date] = useState("");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const navigate = useNavigate();

  // Add Convoy functions
  const handleAddConvoyOpen = () => {
    setAddConvoyOpen(true);
  };

  const handleAddConvoyClose = () => {
    setAddConvoyOpen(false);
    // Reset form
    setConvoyForm({
      user_id: "",
      start_location: "",
      end_location: "",
      start_date: null,
      start_time: "",
      start_address: "",
      status: "0",
      owner_id: "",
      owner_permission: "",
      create_at: "",
    });
  };

  const handleConvoyFormChange = (field, value) => {
    setConvoyForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddConvoySubmit = async () => {
    try {
      const formData = new FormData();

      // Add form fields to FormData
      Object.keys(convoyForm).forEach((key) => {
        if (convoyForm[key] !== null && convoyForm[key] !== "") {
          if (key === "start_date" && convoyForm[key]) {
            // Format date if it's a dayjs object
            const dateValue =
              typeof convoyForm[key].format === "function"
                ? convoyForm[key].format("DD/MM/YY")
                : convoyForm[key];
            formData.append(key, dateValue);
          } else {
            formData.append(key, convoyForm[key]);
          }
        }
      });

      const result = await convoyApis.add(formData);

      if (result.success) {
        showAlert("Convoy added successfully", "success");
        handleAddConvoyClose();
        getData(); // Refresh the table
      } else {
        showAlert(result.message || "Failed to add convoy", "error");
      }
    } catch (error) {
      console.error("Error adding convoy:", error);
      showAlert("Failed to add convoy", "error");
    }
  };

  const [update, setUpdate] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({
    keys: [],
    values: [],
    open: false,
  });

  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleViewMore = () => {
    const rowData = convoyData.filter((row) => row.id === openMenuId);

    navigate(`/Convoy/${openMenuId}`, { state: rowData[0] });

    const { keys, values } = getKeysAndValues(rowData[0]);

    setSelectedRow({ keys, values, open: true });
    // setOpenDialog(true);
  };

  // Function Starts Here

  const [updateMember, setUpdateMember] = React.useState("");
  const [updateLeaveType, setUpdateLeaveType] = React.useState("");

  const [updateDuration, setUpdateDuration] = React.useState("");
  const [updateDate, setUpdateDate] = useState(null); // Initialize state for the date
  const [updateMemberError, setUpdateMemberError] = React.useState(false);
  const [updateReason, setUpdateReason] = useState("");
  const [updateFileName, setUpdateFileName] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [data, SetData] = useState([]);
  const [convoyData, setConvoyData] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const handleUpdateCloseFollow = () => {
    setFollowup(false);
  };
  const handleClickFollowup = () => {
    setFollowup(true);
  };
  const handleFollowup = () => {
    handleClickFollowup();
  };
  const item = {
    member,
    memberError,
    reason,
    duration,
    date,
    leaveType,
    fileName,
  };
  async function Savefollowup() {
    const formData = new FormData();
    const time = new Date();
    const empid = localStorage.getItem("empid");
    formData.append("follow_agent", follow_agent);
    formData.append("follow_date", follow_date);
    formData.append("assigned_by", empid);
    formData.append("assigned_at", time);

    try {
      let response = await fetch(
        ` https://rptpl.roadpilot.co.in/public/api/assignfollowup/${openMenuId}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }

      showAlert(" Followup updated successfully", "success");

      handleUpdateCloseFollow();
      getData(); // Assuming these functions are defined elsewhere in your code
    } catch (error) {
      console.error(error);
      showAlert("Failed to update leads", "error");
    }
  }

  // ends Here

  // Table Starts Here
  const handleChangeSelected = async (event, ticketId) => {
    const selectedValue = event.target.value;

    // Perform any state update or action based on selectedValue and ticketId
    const itemStatus = {
      status: selectedValue,
    };

    // Create a new FormData object
    const formData = new FormData();

    for (const key in itemStatus) {
      if (itemStatus[key] !== undefined && itemStatus[key] !== null) {
        formData.append(key, itemStatus[key]);
      }
    }

    let result = await fetch(
      `https://rptpl.roadpilot.co.in/public/api/changestatus/${ticketId}`,
      {
        method: "POST",
        body: formData,
      }
    );

    await result.json();

    showAlert("updated successfully", "success");

    getData();
  };
  useEffect(() => {
    getData();
  }, [rowsPerPage, pageValue]);

  async function getData() {
    try {
      const result = await ConveyApis.getAll(pageValue, rowsPerPage);

      // Log the entire API response for debugging
      console.log("Convoy API Response:", result);

      if (result?.data) {
        console.log("Convoy records found:", result.data.length);
        setConvoyData(result?.data);
        setTotalPages(result?.total || 0);
        setRowCountValue(result.total || 0);
        setRowsPerPage(result?.data?.per_page || 10);
      } else {
        console.warn("Unexpected response format:", result);
        setConvoyData([]);
        setTotalPages(0);
        setRowCountValue(0);
        setRowsPerPage(10);
      }
    } catch (error) {
      console.error("Error fetching convoy data:", error);
      showAlert(`Failed to load convoy data: ${error.message}`, "error");

      // Set default values to prevent UI errors
      setConvoyData([]);
      setTotalPages(0);
      setRowCountValue(0);
    }
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const columns = [
    {
      name: "app_user",
      label: "Creator",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Creator
            </th>
          );
        },
        customBodyRender: (value) => {
          if (value === null) {
            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                ---
              </span>
            );
          }

          const imageUrl = `${config.apiImageUrl}${value?.image}`;
          return (
            <div
              key={value?.id}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={imageUrl}
                alt={value?.username}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {value?.username || "Unknown"}
                </div>
                <div style={{ color: "gray" }}>
                  {value?.user_id || "Unknown"}
                </div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "start_location",
      label: "Convoy",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Convoy
            </th>
          );
        },

        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta?.rowData[0];

          const fullRecord = convoyData.find(
            (item) => item?.user_id === ticketId?.user_id
          );

          if (!fullRecord) {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                ---
              </div>
            );
          }

          const finalLocation = fullRecord?.end_location;

          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: "12px", color: "#333" }}>
                  <b>Start Location</b>: {value || "N/A"}
                </div>
                <div style={{ fontSize: "12px", color: "#333" }}>
                  <b>End Location</b>: {finalLocation || "N/A"}
                </div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "created_at",
      label: "Time",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Time
            </th>
          );
        },
        customBodyRender: (value) => {
          const date = new Date(value);
          const formattedDate = format(date, "dd/MM/yyyy, HH:mm:ss");
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {formattedDate || " N/A"}
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Select
                value={value}
                onChange={(event) => handleChangeSelected(event, ticketId)}
                displayEmpty
                renderValue={(selected) => {
                  if (selected === "1") {
                    return (
                      <MenuItem sx={{ display: "flex", alignItems: "center" }}>
                        Open
                      </MenuItem>
                    ); // Placeholder text
                  }
                  if (selected === "2") {
                    return (
                      <MenuItem sx={{ display: "flex", alignItems: "center" }}>
                        Suspended
                      </MenuItem>
                    ); // Placeholder text
                  }
                  if (selected === "0") {
                    return (
                      <MenuItem sx={{ display: "flex", alignItems: "center" }}>
                        Closed
                      </MenuItem>
                    ); // Placeholder text
                  }
                  return selected; // Show selected value
                }}
                sx={{
                  width: "110px",

                  border: "none",
                  color: "#000 ",
                  bgcolor: "#fff",
                  "& .MuiSelect-select": {
                    padding: 0,
                  },
                }}
              >
                <MenuItem
                  value={1}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Open
                </MenuItem>
                <MenuItem
                  value={0}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Closed
                </MenuItem>
                <MenuItem
                  value={2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Suspended
                </MenuItem>
              </Select>
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "20px", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "20px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userPermissions.convoy_view && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleViewMore(tableMeta.rowData)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <RemoveRedEyeIcon /> View More
                      </div>
                    </MenuItem>
                  )}

                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={handleFollowup}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <AssignmentIndIcon /> Follow Up
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleNotes(value)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <EditNoteIcon /> Notes
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleDelete(value)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <DeleteForeverIcon /> Close
                    </div>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];

  const handleNotes = () => {
    setOpenNotes(true);
  };

  // Update Values Start

  useEffect(() => {
    setUpdateMember(data.member);
  }, [data.member]);

  useEffect(() => {
    setUpdateDate(data.date);
  }, [data.date]);

  useEffect(() => {
    setUpdateDuration(data.duration);
  }, [data.duration]);

  useEffect(() => {
    setUpdateMemberError(data.managerError);
  }, [data.managerError]);

  useEffect(() => {
    setUpdateFileName(data.fileName);
  }, [data.fileName]);

  useEffect(() => {
    setUpdateReason(data.reason);
  }, [data.reason]);

  useEffect(() => {
    setUpdateLeaveType(data.leaveType);
  }, [data.leaveType]);

  useEffect(() => {
    setUpdateStatus(data.status);
  }, [data.status]);
  const handleCloseNotes = () => {
    setOpenNotes(false);
  };

  const itemNotes = {
    leaveType,
  };

  async function SaveNotes() {
    let result = await fetch(
      "https://rptpl.roadpilot.co.in/public/api/addBusinesslocation",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      }
    );

    result = await result.json();

    showAlert("Notes Added successfully", "success");

    getData();
    setOpenNotes(false);
  }
  async function UpdateData() {
    const formData = new FormData();

    formData.append("member", updateMember);
    formData.append("memberError", updateMemberError);
    formData.append("fileName", updateFileName);
    formData.append("date", updateDate);
    formData.append("reason", updateReason);
    formData.append("duration", updateDuration);
    formData.append("leaveType", updateLeaveType);
    formData.append("status", updateStatus);
    try {
      let response = await fetch(
        `https://rptpl.roadpilot.co.in/public/api/updateBusinessLocation/${data.id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }

      showAlert("Leave updated successfully", "success");

      handleUpdateClose();
      getData(); // Assuming these functions are defined elsewhere in your code
    } catch (error) {
      console.error(error);
      showAlert("Failed to update business location", "error");
    }
  }

  // Editing Ends Here

  // Delete

  async function handleDelete(id) {
    const response = await fetch(
      " https://rptpl.roadpilot.co.in/public/api/businesslocationdelete/" + id,
      {
        method: "DELETE",
      }
    );
    const result = await response.json(); // Assigning to a new variable

    getData();
    showAlert("Leave Deleted successfully", "warning");
  }

  // end delete

  const rowsPerPageOptions = [5, 10, 25, 100];

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    totalPages: totalPages, // Adding total pages
    onChangePage: (currentPage) => {
      setPageValue(currentPage + 1);
    },
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {page * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => changeRowsPerPage(Number(e.target.value))}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {page + 1} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => changePage(page + 1)}
                disabled={page + 1 === totalPages}
                sx={{
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };

  const theme = createTheme({
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            backgroundColor: "lightblue", // Change this to your desired color
          },
        },
      },
      MuiPickersCalendarHeader: {
        styleOverrides: {
          root: {
            backgroundColor: "lightblue", // Change this to your desired color
          },
        },
      },
    },
  });
  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Table Ends Here

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <Dialog
        fullWidth
        maxWidth="md"
        open={openNotes}
        onClose={handleCloseNotes}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseNotes}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Add Convoy Note
            </Typography>
          </Toolbar>
        </AppBar>
        <Box>
          <Grid
            container
            spacing={2}
            style={{ color: "black", margin: "10px", zIndex: "4000" }}
          >
            <Grid item xs={10} sm={8} md={6}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Note Title
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={10} sm={8} md={6}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    placeholder="Title "
                    onChange={(e) => setFileName(e.target.value)}
                    inputProps={{
                      style: {
                        color: "black",
                        border: "1px solid black",
                        borderRadius: "5px",
                      },
                    }}
                    InputLabelProps={{ style: { color: "black" } }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black",
                        "&:hover fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        "&::placeholder": { color: "gray" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={10} sm={8} md={6}>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{
                    color: "black",

                    padding: "4px",
                    borderRadius: "4px",
                  }}
                >
                  Note Type
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value="Public"
                    control={
                      <Radio
                        sx={{
                          color: "black",
                          "&.Mui-checked": { color: "gray" },
                        }}
                      />
                    }
                    label="Public"
                  />
                  <FormControlLabel
                    value="Private"
                    control={
                      <Radio
                        sx={{
                          color: "black",
                          "&.Mui-checked": { color: "gray" },
                        }}
                      />
                    }
                    label="Private"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: "20px" }}>
            <Stack direction="column" sx={{ width: "100%" }}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Notes Detail<span style={{ color: "red" }}>*</span>
              </Typography>

              <ReactQuill
                value={date}
                onChange={() => {}}
                // modules={modules}
                // theme="snow"
                style={{
                  // border: '1px solid black',
                  // borderRadius: '4px',
                  //padding: '10px',
                  width: "100%",
                  boxSizing: "border-box",
                  color: "black",
                  borderBlockColor: "black",
                  // minHeight: '100px' // Set your desired minimum height
                }}
              />
            </Stack>
          </Grid>
          <br />
          <br />

          <Button
            variant="contained"
            autoFocus
            color="inherit"
            onClick={SaveNotes}
            sx={{
              backgroundColor: "blue",
              "&:hover": { backgroundColor: "orange" },
              textAlign: "center",
              margin: "25px",
            }}
          >
            Save
          </Button>
        </Box>
      </Dialog>

      {/* Follow up box  */}
      <Box sx={{ zIndex: 11000 }}>
        <Dialog
          open={followup}
          fullWidth
          maxWidth="md"
          onClose={handleUpdateCloseFollow}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateCloseFollow}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component="div">
                Follow Up
              </Typography>
            </Toolbar>
          </AppBar>

          <Box sx={{ backgroundColor: "white" }}>
            <Grid
              container
              spacing={2}
              style={{
                color: "black",
                margin: "10px",
              }}
            >
              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Follow Agent
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Autocomplete
                      options={optionsAgent}
                      sx={{ border: "1px solid gray", borderRadius: "5px" }}
                      value={follow_agent}
                      onChange={(event, newValue) => {
                        setFollow_agent(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          fullWidth
                          placeholder="ex. abc"
                          inputProps={{
                            ...params.inputProps,
                            style: {
                              color: "black",
                            },
                          }}
                          InputLabelProps={{
                            style: {
                              color: "black",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Follow Date
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <ThemeProvider theme={theme}>
                      <CssBaseline />
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Date"
                          PaperProps={{
                            sx: {
                              "& .MuiPickersCalendarHeader-root": {
                                backgroundColor: "lightblue", // Change this to your desired color
                              },
                              "& .MuiPickersDay-root": {
                                backgroundColor: "lightblue", // Change this to your desired color
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              autoFocus
              color="inherit"
              onClick={Savefollowup}
              sx={{
                backgroundColor: "blue",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                margin: "25px",
              }}
            >
              Update
            </Button>
          </Box>
        </Dialog>
      </Box>
      <List
        style={{
          background: "none",
          // padding: 5,
        }}
      >
        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <Box
              sx={{
                maxWidth: "100%", // Ensure it doesn't exceed the parent container
              }}
            >
              {/* Add Convoy Button */}
              <Box
                sx={{ mb: 2, display: "flex", justifyContent: "flex-start" }}
              >
                <Button
                  variant="contained"
                  onClick={handleAddConvoyOpen}
                  sx={{
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#1565c0" },
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                >
                  Add Convoy
                </Button>
              </Box>

              <MUIDataTable
                title={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#333",
                    }}
                  >
                    Convoy Lists
                  </span>
                }
                data={convoyData}
                columns={columns}
                options={options}
              />
            </Box>
          </ThemeProvider>
        </ListItemText>
      </List>

      {/* Add Convoy Drawer */}
      <Drawer
        anchor="right"
        open={addConvoyOpen}
        onClose={handleAddConvoyClose}
        PaperProps={{
          sx: {
            width: "75%",
            maxWidth: "none",
            padding: 3,
            backgroundColor: "#ffffff",
            color: "#000000",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            padding: 2,
            backgroundColor: "#ffffff",
            color: "#000000",
          }}
        >
          <AppBar
            position="static"
            sx={{
              mb: 3,
              borderRadius: 1,
              backgroundColor: "#f5f5f5",
              color: "#000000",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Toolbar>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  color: "#000000",
                  fontWeight: "bold",
                }}
              >
                Add Convoy
              </Typography>
              <IconButton
                edge="end"
                onClick={handleAddConvoyClose}
                aria-label="close"
                sx={{ color: "#000000" }}
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="User ID"
                placeholder="testing1234556"
                value={convoyForm.user_id}
                onChange={(e) =>
                  handleConvoyFormChange("user_id", e.target.value)
                }
                variant="outlined"
                required
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Start Location"
                placeholder="Chennai"
                value={convoyForm.start_location}
                onChange={(e) =>
                  handleConvoyFormChange("start_location", e.target.value)
                }
                variant="outlined"
                required
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="End Location"
                placeholder="Tirupati"
                value={convoyForm.end_location}
                onChange={(e) =>
                  handleConvoyFormChange("end_location", e.target.value)
                }
                variant="outlined"
                required
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Start Date"
                  value={convoyForm.start_date}
                  onChange={(newValue) =>
                    handleConvoyFormChange("start_date", newValue)
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "outlined",
                      placeholder: "11/10/24",
                      sx: {
                        backgroundColor: "#ffffff",
                        "& .MuiInputLabel-root": {
                          color: "#000000",
                        },
                        "& .MuiOutlinedInput-root": {
                          color: "#000000",
                          backgroundColor: "#ffffff",
                          "& fieldset": {
                            borderColor: "#cccccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#1976d2",
                          },
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color: "#666666",
                          opacity: 1,
                        },
                      },
                    },
                    popper: {
                      sx: {
                        "& .MuiPaper-root": {
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "1px solid #cccccc",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Start Time"
                placeholder="12:00 PM"
                value={convoyForm.start_time}
                onChange={(e) =>
                  handleConvoyFormChange("start_time", e.target.value)
                }
                variant="outlined"
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Start Address"
                placeholder="Porur"
                value={convoyForm.start_address}
                onChange={(e) =>
                  handleConvoyFormChange("start_address", e.target.value)
                }
                variant="outlined"
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <FormLabel
                  component="legend"
                  sx={{
                    mb: 1,
                    color: "#000000",
                    "&.Mui-focused": {
                      color: "#000000",
                    },
                  }}
                >
                  Status
                </FormLabel>
                <Select
                  value={convoyForm.status}
                  onChange={(e) =>
                    handleConvoyFormChange("status", e.target.value)
                  }
                  displayEmpty
                  sx={{
                    backgroundColor: "#ffffff",
                    color: "#000000",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#cccccc",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                    "& .MuiSelect-icon": {
                      color: "#000000",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: "#ffffff",
                        color: "#000000",
                        border: "1px solid #cccccc",
                        "& .MuiMenuItem-root": {
                          color: "#000000",
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#e3f2fd",
                            "&:hover": {
                              backgroundColor: "#bbdefb",
                            },
                          },
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="0">Closed</MenuItem>
                  <MenuItem value="1">Open</MenuItem>
                  <MenuItem value="2">Suspended</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Owner ID"
                placeholder="Testing789654123"
                value={convoyForm.owner_id}
                onChange={(e) =>
                  handleConvoyFormChange("owner_id", e.target.value)
                }
                variant="outlined"
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Owner Permission"
                value={convoyForm.owner_permission}
                onChange={(e) =>
                  handleConvoyFormChange("owner_permission", e.target.value)
                }
                variant="outlined"
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Create At"
                placeholder="039"
                value={convoyForm.create_at}
                onChange={(e) =>
                  handleConvoyFormChange("create_at", e.target.value)
                }
                variant="outlined"
                sx={{
                  backgroundColor: "#ffffff",
                  "& .MuiInputLabel-root": {
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#000000",
                    backgroundColor: "#ffffff",
                    "& fieldset": {
                      borderColor: "#cccccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#999999",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#666666",
                    opacity: 1,
                  },
                }}
              />
            </Grid>
          </Grid>

          <Box
            sx={{
              mt: 4,
              display: "flex",
              gap: 2,
              justifyContent: "flex-end",
              backgroundColor: "#ffffff",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleAddConvoyClose}
              sx={{
                minWidth: 120,
                color: "#000000",
                borderColor: "#cccccc",
                backgroundColor: "#ffffff",
                "&:hover": {
                  borderColor: "#999999",
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddConvoySubmit}
              sx={{
                minWidth: 120,
                backgroundColor: "#1976d2",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
            >
              Add Convoy
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default Convoy;
